/*
UserPermissionMixin will hold all user permission check related functions which are used in almost every component or views-
*/
import { mapGetters } from "vuex";
import { UserGroup } from "../services/UserGroups";
// @group Mixins
export default {
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal"
    ])
  },
  methods: {
    userExternalCheck() {
      if (
        this.userGroups.includes(UserGroup.EXTERNAL_USER) &&
        this.isUserExternal
      ) {
        return true;
      }
      return false;
    }
  }
};
